<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <!--返回上一层-->
      <span class="topT"  >会员登录</span>
      <!--<mu-icon value="keyboard_arrow_left" color="white" slot="left" v-on:click="goback" />-->
      <!--<mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />-->
    </mu-appbar>

  <!-- <div style="color: #FFFFFF;    font-size: 0.42rem;    position: relative;    top: 4px;">
    会员登录
  </div> -->
  
    <br />

    <div class="bigpage">
      <div>
        <div align="left" style="margin-top:2vh">
          <!--<mu-divider class="dividerClass"/>-->
          <mu-text-field hintText="请输入手机号" type="text" icon="smartphone" v-model="UserPhone" fullWidth="" style="margin-left:-4% ; width:103% " />
          <nobr>
            <!--图片附加码-->
            <mu-text-field hintText="请输入附加码" type="text" icon="vpn_key" v-model="FJM1" class="txtValidate" style="margin-left:-4% ; width:69%;display:none " />
            <img v-bind:src="TPFJM" style="width:30% ;   float:right;   margin-top: -0.1rem;display:none" v-on:click="this.getValidateCode" />
          </nobr>

          <nobr>
            <mu-text-field hintText="请输入手机验证码" type="text" icon="verified_user" v-model="YZM" class="txtValidate" style="margin-left:-4% ; width:69% ; z-index: 1" />
            <span v-show="haveYZM == false">
              <input type="button" id="j-popup" @click="NetEaseDunClick" value="获取" style="font-size:0.3rem ; float:right ; background-color:#27ba69 ; height: 0.7rem  ; border:none  ;  width: 30% ;  color:white" />
            </span>
            <span v-show="haveYZM == true">
              <input type="button" v-model="WaitTime" style="font-size:0.32rem ; float:right ;   background-color:#eeeeee ;   height: 0.7rem  ; border:none  ;  width: 30% ; color:#999 ;" />
            </span>
          </nobr>
        </div>

        <mu-raised-button label="登录/注册" primary="" @click="QuickLogin" v-bind:style="{ width:'100%', height:'0.8rem' }" style="font-size: 0.3rem ; margin-top:0.2rem " />
      </div>
      <!--快捷登录  end-->
    </div>
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />
    <div id="captcha"></div>
    <!-- <pop :display='popDisplayA' @closeHandler='closePop' @okHandler='closeYESA' title='提示' :msg='popMsg' :onlyOk='popOnlyOk' /> -->
  </div>
  
</template>


<script>
import { mapMutations, mapGetters } from 'vuex'
import api from '../../../api'

export default {
  data() {
    return {
      activeTab: 'tab2',

      //  输入框初始化 1
      UserName: '',
      UserPass: '',
      haorem: true,
      FJM1: '',

      FJMPD: false,

      //  输入框初始化  END

      //  附加码图片
      TPFJM: '',

      //  输入框初始化 2
      UserPhone: '',
      YZM: '',
      //  输入框初始化  END  2

      // 弹出层 弹出内容
      toast: false,
      TellUser: '',
      // 弹出层 弹出内容  END

      haveYZM: false,
      WaitTime: '',
      Time: 59,

      urls: '',
      //网易云盾验证码
      validate: '',

      verify: {
          CodeGuid:"",
          VerifyCode:"",
          VerifyType:0,
      },

      //屏幕宽度
      WinWidth: document.body.clientWidth,
      //  popDisplayA: false,
      // popOnlyOk: false,
      // popMsg: "未激活无法进行预定，是否先激活",
      // cardname:'',
      // cardphone:'',
      // cardkind:'',
      // cardno:'',
      //用户侧公网IP
      ip_address : returnCitySN["cip"],
    }
  },

  //进入时运作
  activated() {
    this.FJM1 = ''
    //20180727 xulong  wifi跳转页面默认跳转
      if ( this.$route.query.usr!= undefined )
            {
               this.UserPhone=this.$route.query.usr; //获取转入参数 手机号码
            }
      if ( this.$route.query.activeTab!= undefined )
            {
               this.activeTab=this.$route.query.activeTab; //获取转入参数 手机号码
            }

    this.getValidateCode()
    // this.CheckLogin();   登录页循环判定是否登录，先不放

    let that = this;
    _fmOpt.onSuccess = function (validateToken) {
        
        var params = new that.URLSearchParam();
        params.append("phoneNo", that.UserPhone);
        params.append("captcha", validateToken);
        
        that.$http.post(api.getYdSMSLoginCode2(), params.toParam()).then(res => {
          if (res.Result == true) {
            that.TellUser = "验证码已发送";

            that.haveYZM = true;
            that.WaitTime = this.Time + "秒";
            that.timer();

          } else {
            // 失败
            that.TellUser = res.Message;
          }
          that.showToast();
        });
    }
  },

  created() {
    this.getUnionLoginUrl()
    this.getVerifyImgCode();
  },

  // 数据获取
  computed: {
    ...mapGetters(['g_UserInfo', 'g_loginInfo'])
  },
  methods: {
    ...mapMutations(['setG_UserInfo', 'setG_loginInfo']),

    // 图片验证码
    getValidateCode() {
      // 用户已登录
      if (this.g_UserInfo.Card_no) {
        // console.log(this.g_UserInfo)
        this.$router.replace({ path: '/user/UserCenter' })
      }
      else{
        this.TPFJM = api.getValidateCode()
        this.InitNetEaseDun()
      }
    },

    //获取验证方式
    getVerifyImgCode() {
        this.$http.get(api.getVerifyImgCode()).then(res => {
            if (res.Result == true) {
                this.verify = res.Data;
            } else {
            // 失败
                this.TellUser = res.Message;
            }
        });
    },

    SaveUserInfo(result) {
      // 保存登录信息
      // 保存登录信息
      var UserInfo = result

      if (UserInfo.Card_Kind_Diplay == '网上数字卡') {
        UserInfo.Card_Kind_Diplay = '数字卡'
      }

      UserInfo.OrderRefresh1 = true
      UserInfo.OrderRefresh2 = true
      UserInfo.OrderRefresh3 = true

      // 保存登录信息
      this.setG_UserInfo(UserInfo)

      this.UserName = ''
      this.UserPass = ''
      this.FJM1 = ''
      this.YZM = ''

      if (this.$route.query.backURL) {
        // this.$router.push({ path: this.$route.query. });
        window.location.href = this.$route.query.backURL
      } else {
        this.goback()
      }
    },


    //  获取验证码
    getYZM() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
      } else {
        this.haveYZM = true
        this.WaitTime = this.Time + '秒'
        this.timer()
      }
    },
    timer() {
      if (this.Time > 0) {
        this.Time--
        this.WaitTime = this.Time + '秒'

        setTimeout(this.timer, 1000)
      } else if (this.Time == 0) {
        this.haveYZM = false
        this.Time = 59
      }
    },
    //手机短信验证码
    getSmsYZM() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
      } else {
        this.haveYZM = true
        this.WaitTime = this.Time + '秒'
        this.timer()
      }
      var params = new this.URLSearchParam()
      params.append('phoneNo', this.UserPhone)
      params.append('captcha', this.validate)

      this.$http.post(api.getYdSMSLoginCode(), params.toParam()).then(res => {
        window.captchaInsD.refresh() //清理验证码
        if (res.Result == true) {
          this.TellUser = res.Data
          this.showToast()
        } else {
          // 失败
          this.TellUser = res.Message
          this.showToast()
          this.FJM1 = ''
          this.Time = 5
        }
      })
    },
    //   closePop() {
    //   this.popDisplayA = false;
    // },
    // closeYESA() {
    //   this.popDisplayA = false;
    //    console.log(this.cardphone);
    //    this.$router.push({ path: "/user/activation?cardkind="+this.cardkind+"&cardno="+this.cardno+"&cardphone="+this.cardphone+"&cardname="+this.cardname})
    // //  this.$router.push({ path: "/user/activation",params:{cardkind:this.cardkind,cardno:this.cardno,cardphone:this.cardphone,cardname:this.cardname}});
    // },
    //  快捷登录
    QuickLogin() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
      } else if (this.Verification2 == '') {
        this.password = '请输入附加码'
        this.showToast()
      } else if (this.YZM == '') {
        this.TellUser = '请输入动态密码'
        this.showToast()
      } else {
        var params = new this.URLSearchParam()
        params.append('activityID', 20)
        params.append('fokasDetailID', this.$route.query.fokasId||0)
        params.append('type', this.$route.query.sharetype)
        params.append('parentUserCode', this.$route.query.parentId)
        params.append('phoneNo', this.UserPhone)
        params.append('validateCode', this.YZM)
        //  快捷登录
        this.$http.post(api.QuickVerificationFokas(), params.toParam()).then(res => {
          if (res.Result == true) {
            // localStorage.setItem('g_userId_2020Spring',res.Data.Data.CardNo)
            location.href = 'https://h5app.greentree.cn/2020Spring/index.html#/?userCode='+res.Data.Data.CardNo+'&fokasId='+(this.$route.query.fokasId||0);
            // location.href = 'https://h5minitest.greentree.cn/2020Spring/index.html#/?userCode='+res.Data.Data.CardNo+'&fokasId='+(this.$route.query.fokasId||0);
          } else {
            this.TellUser = res.Message;
            this.showToast()
          }
        })
      }
    },
    //  快捷登录  END

    handleTabChange(val) {
      this.activeTab = val
      if (val == 'tab2') {
        
      }
    },

    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => {
        this.toast = false
      }, 2500)
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    // 弹出层  end

    // 弹出标签 选择是否
    open() {
      this.dialog = true
    },
    closeYES() {
      this.dialog = false
      //调用弹出层
      this.showToast()
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false
    },
    // END 弹出标签 选择是否

    // 后退一页
    goback() {
      javascript: history.go(-1)
      //this.$router.go(-1)
      //console.log('i come')
    },

    getUnionLoginUrl() {
      this.$http.post(api.getUnionLoginUrl()).then(res => {
        this.urls = res.Data
        console.log(this.urls)
      })
    },
    //初始化易盾
    InitNetEaseDun() {
      if (window.captchaInsD != undefined) {
        return
      }
      //网易云盾初始化
      var that = this;
      var captchaIns
      var winWidth = this.WinWidth <= 320 ? 'auto' : '280'
      initNECaptcha(
        {
          element: '#captcha',
          captchaId: '883464f032c9481a891b5fb9fb49bd23',
          mode: 'popup',
          width: winWidth,
          onVerify: function(err, data) {
            if (
              err != undefined ||
              data == undefined ||
              data.validate == undefined
            ) {
              that.validate = ''
              that.TellUser = '验证有误！请重新验证'
              that.toastTimer = 5
              that.showToast()
              return
            }
            that.validate = data.validate
            that.getSmsYZM()
          }
        },
        function(instance) {
          // 初始化成功后得到验证实例instance，可以调用实例的方法
          captchaIns = instance
          window.captchaInsD = captchaIns
        },
        function(err) {
          // 初始化失败后触发该函数，err对象描述当前错误信息
        }
      )
    },
    NetEaseDunClick() {
      if (this.UserPhone == '') {
        this.TellUser = '请输入手机号'
        this.showToast()
      } else if (this.UserPhone.length != 11) {
        this.TellUser = '手机号格式不正确'
        this.showToast()
      } else {
        // if (this.verify.VerifyType == 1) {
        //         //自研
        //         this.getVerifyImgCode();
        //         this.showVerifyCode = true;
        //     }
            if (this.verify.VerifyType == 2) {
                //同盾
                _fmOpt.triggerCaptcha();
            }
            if (this.verify.VerifyType == 3) {
                //易盾
                if (this.validate.length > 0) {
                    window.captchaInsD.refresh();
                }
                window.captchaInsD.popUp();
            }
      }
    }
  }
}
</script>


<style lang="less" >

.pageContent .mu-appbar-title {
    text-align: center;
    margin-top: -10px;
}

@import '../../../assets/theme.less'; // 顶部标签变换
.mu-tabs {
  // 背景色
  background-color: #fff;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
.pageContent {
  position:fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background-color: #fff;
  max-width: 480px; // margin-left: auto;
  // margin-right: auto;
  // text-align: center;
  .bigpage {
    width: 80%;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .Green {
    background-color: @primaryColor;
  }

  .Black {
    color: @primaryBlack;
  }

  .Grey {
    color: @textColor;
  } // .txtValidate {
  //   .mu-text-field-content {
  //     .mu-text-field-hint {
  //       width: 120px;
  //      border:1px dashed #000;
  //     }
  //   }
  // }
  .mu-tabs {
    background-color: #fff;
    .mu-tab-link {
      color: @greyFontColor;
    }
    .mu-tab-active {
      color: @primaryColor;
    }
    .mu-text-field-line {
      background-color: #fff;
    }
  }
}
.unionLogin {
  margin-bottom: 56px;
  clear: both;
  .top {
    color: #999999;
    font-size: 0.3rem;
    display: flex;
    justify-content: center;
    margin: 2rem 0.6rem 0 0.6rem;
    .line {
      border-top: 1px solid #cccccc;
      height: 0px;
      margin: auto 0.1rem;
      flex-grow: 1;
    }
  }
  .btns {
    margin-top: 0.52rem;
    display: flex;
    justify-content: center;
    img {
      width: 0.8rem;
      height: 0.8rem;
    }
    .center {
      margin: 0 0.5rem;
    }
  }
}
</style>






// WEBPACK FOOTER //
// 2020SpringLogin.vue?38431eec